import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer2PraceZiemne() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/prace-ziemne-Large.jpeg"
          alt="Prace ziemne - roboty ziemne - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Prace ziemne i roboty minikoparką pod budowę Gdańsk, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Wykopy fundamentowe, przyłącza i wymiana gruntu na Pomorzu
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Każda udana inwestycja budowlana w Gdańsku, Gdyni, Kartuzach czy Wejherowie zaczyna się od fachowo wykonanych prac ziemnych. Realizujemy wykopy pod fundamenty domów, przyłącza wodno-kanalizacyjne, szamba, drenaże oraz korytowanie pod drogi dojazdowe. Ciężki i nowoczesny park maszynowy gwarantuje precyzję, która ułatwia późniejsze <a href="/zakladanie-ogrodu/kompleksowo" className="underline hover:opacity-80">zakładanie ogrodu</a>.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Wykopy pod fundamenty, instalacje i ogrodzenia
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Korytowanie i przygotowanie terenu pod kostkę i drogi dojazdowe
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Roboty ziemne na działkach prywatnych i inwestycyjnych
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Porządkowe roboty ziemne
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Roboty ziemne wykończeniowo-porządkowe
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Dlaczego warto wybrać naszą firmę
            </a>
            <a
              href="#7"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Ile kosztują roboty ziemne
            </a>
            <a
              href="#8"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Grunt to dobry wykonawca
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Wykopy pod fundamenty, instalacje i ogrodzenia</h2>
          <p>
            <strong>Roboty ziemne</strong> są niezbędne nie tylko na placu
            budowy. Będą konieczne również przy niwelacji terenu, porządkowaniu
            działki oraz zakładaniu ogrodu. Sprawdź naszą ofertę i wybierz
            rodzaj prac, który najbardziej odpowiada Twoim potrzebom.
          </p>
          <p>
            Pamiętaj, wybierając jedną ekipę do wszystkich robót ziemnych i
            innych prac na działce, zapłacisz mniej w porównaniu do zlecenia
            tych robót różnym firmom.
          </p>

          <h2 id="2">Korytowanie i przygotowanie terenu pod kostkę i drogi dojazdowe</h2>
          <p>Roboty ziemne dzielą się na:</p>
          <ul>
            <li>
              <strong>roboty ziemne podstawowe</strong>
            </li>
            <li>
              <strong>roboty ziemne porządkowe</strong>
            </li>
            <li>
              <strong>roboty ziemne wykończeniowo-porządkowe</strong>
            </li>
          </ul>
          <p>
            Tego typu roboty ziemne najlepiej zlecić nam do wykonania. Posiadamy
            niezawodny sprzęt i doświadczonych operatorów koparek, którzy w
            tarcie swojej pracy przerzucili mnóstwo ziemi. Dzięki temu sprawnie
            wykonujemy wszelkiego rodzaju roboty ziemne.
          </p>

          <h2 id="3">Roboty ziemne na działkach prywatnych i inwestycyjnych</h2>
          <p>
            Działamy kompleksowo, więc nasza ekipa może wykonać najróżniejsze
            prace na Twojej działce. Wśród usług, które wykonujemy, znajdziesz
            m.in. podstawowe roboty ziemne, do których zaliczają się:
          </p>
          <ul>
            <li>wykopy rowów</li>
            <li>wykop pod skarpę</li>
            <li>wykop pod szambo</li>
            <li>kształtowanie terenu</li>
            <li>wykop pod piwniczkę</li>
            <li>wykop pod ziemiankę</li>
            <li>wykopy pod rury kanalizacyjne</li>
            <li>wykopy pod przyłącza gazowe</li>
            <li>wykopy pod fundamenty domu</li>
            <li>wykopy pod kable energetyczne i światłowody</li>
            <li>wykop i utwardzenie drogi dojazdowej do posesji</li>
          </ul>

          <h2 id="4">Porządkowe roboty ziemne</h2>
          <p>
            Wykonamy dla Ciebie również porządkowe roboty ziemne. Do takich
            robót zalicza się:
          </p>
          <ul>
            <li>wycinka drzew</li>
            <li>frezowanie pni</li>
            <li>niwelacja terenu</li>
            <li>mulczowanie terenu</li>
            <li>karczowanie pniaków</li>
            <li>usuwanie pniaków z korzeniami pozostałych po wycince drzew</li>
          </ul>

          <h2 id="5">Roboty ziemne wykończeniowo-porządkowe</h2>
          <p>
            Takie prace również możesz zlecić w naszej firmie. Obejmują one:
          </p>
          <ul>
            <li>mikroniwelacje</li>
            <li>wyrównywanie skarp</li>
            <li>profilowanie nasypów</li>
            <li>zagęszczanie podłoży i skarp</li>
            <li>zbieranie żyznej warstwy ziemi</li>
            <li>wykopy pod stopy i ławy fundamentowe</li>
            <li>układanie darni oraz ziemi roślinnej w terenie</li>
            <li>wyrównywanie dna szerokoprzestrzennych wykopów</li>
          </ul>
          <p>
            Powierzchniowe roboty ziemne można wykonywać ręcznie, ale zajmuje to
            wiele czasu i jest bardzo pracochłonne. Dlatego tu o wiele bardziej
            sprawdzą się maszyny, takie jak koparka czy miniładowarka z
            osprzętem dopasowanym do wykonywanej pracy.
          </p>

          <h2 id="6">Dlaczego warto wybrać naszą firmę</h2>
          <p>
            Pracujemy na sprzęcie renomowanych firm, a nasi operatorzy to
            umiejętni fachowcy, więc możesz powierzyć nam prace przygotowawcze
            czy wykończeniowe roboty ziemne.
          </p>
          <p>
            Nasza ekipa jest wykwalifikowana w tego typu pracach, a dodatkowo
            specjalizujemy się w ogrodnictwie, dzięki czemu możemy kompleksowo
            wykonań dla Ciebie różne prace.
          </p>
          <p>
            Nie boimy się pobrudzić, zamoczyć, czy wykonać różnego rodzaju
            robót, które sprawią, że na Twojej działce powstanie piękny ogród
            czy teren równy jak stół idealnie przygotowany pod sprzedaż czy
            inwestycję.
          </p>

          <h2 id="7">Ile kosztują roboty ziemne</h2>
          <p>
            Koszt przeprowadzenia prac ziemnych i innych robót, które nam
            zlecisz, możemy wycenić również osobiście na miejscu. Na wycenę
            przyjedziemy nieodpłatnie, a przy okazji doradzimy najlepsze
            rozwiązania oraz podpowiemy, co jeszcze można zrobić na działce.
          </p>
          <p>
            Ceny robót ziemnych są ściśle powiązane z zakresem wykonywanych
            prac. Dlatego koszt robót ziemnych można oszacować w zależności od
            rodzaju i specyfiki prac budowlanych. Chętnie Ci w tym pomożemy.
            Wystarczy, że wypełnisz formularz wskazując zakres prac, a
            przygotujemy dla Ciebie wycenę.
          </p>
          <p>
            Zlecając nam więcej rodzajów prac, całość wyjdzie cenowo bardziej
            korzystnie. Dotyczy to między innymi kosztów transportu sprzętu
            niezbędnego do wykonania robót.
          </p>

          <h2 id="8">Grunt to dobry wykonawca</h2>
          <p>
            Ręczne kopanie to nie rozwiązanie przy przygotowywaniu terenu pod
            budowę. Zamiast tego lepiej skorzystać ze specjalistycznego sprzętu,
            jakim są koparki. Nasza ekipa wykorzystuje nie tylko sprawdzone
            maszyny, ale też doświadczenie zawodowe niezbędne przy tego typu
            pracach.
          </p>
          <p>
            W naszej ofercie znajdziesz nie tylko niwelacje terenu, usuwanie
            zbędnej roślinności czy różnego rodzaju prace porządkowe na
            działkach budowlanych, rolnych, siedliskowych, ale również wykonanie
            i utwardzenie drogi dojazdowej do posesji oraz założenie ogrodu od
            podstaw, zarówno według projektu projektanta, jak i według koncepcji
            inwestora.
          </p>
          <p>
            Możemy też wspólnie omówić i stworzyć koncepcję zagospodarowania
            Twojej działki czy innego terenu. My znamy się na rzeczy, więc
            możesz liczyć na nasze kompetencje.
          </p>
          <p>
            Daj znać czego potrzebujesz, a wykonamy dla Ciebie prace ziemne.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-0.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-1.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-2.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-3.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-4.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-5.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/prace-ziemne.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 7"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-7.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 8"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-8.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 9"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer2PraceZiemne;